var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50093 5.99983V7.33317M8.50093 9.99983H8.50759M3.88226 12.6665H13.1196C14.1463 12.6665 14.7876 11.5552 14.2743 10.6665L9.65559 2.6665C9.14226 1.77783 7.85959 1.77783 7.34626 2.6665L2.72759 10.6665C2.21426 11.5552 2.85559 12.6665 3.88226 12.6665Z",
    stroke: "#F7941E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMobileIcon);
export default __webpack_public_path__ + "static/media/warning-mobile-icon.57aa80056024b74f2b79b986d20ad2c1.svg";
export { ForwardRef as ReactComponent };